var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleAssetLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 66,
    viewBox: "0 0 65 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.601562,
    width: 65,
    height: 65,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7777 31.1135L33.425 39.2402C33.1457 39.3834 32.8121 39.3834 32.5329 39.2402L16.1801 31.1135L10.9926 33.6918L32.9789 44.6179L54.9653 33.6918L49.7777 31.1135ZM49.7777 37.4814L54.9653 40.058L32.9789 50.9859L10.9925 40.058L16.1801 37.4814L32.5328 45.6063C32.8121 45.7495 33.1457 45.7495 33.4249 45.6063L49.7777 37.4814ZM49.0778 16.8203C46.8531 14.5973 43.3699 14.2547 40.7571 16.0025C38.1425 17.7486 37.1271 21.0991 38.3311 24.0021C39.535 26.9067 42.6228 28.5567 45.7054 27.9421C48.7895 27.3274 51.009 24.6222 51.009 21.478C51.0108 19.7302 50.3162 18.0531 49.0778 16.8203ZM37.3213 18.5555C36.3259 20.9724 36.6287 23.7287 38.1264 25.8717C39.6223 28.0149 42.1045 29.2497 44.7171 29.1481C47.3281 29.0466 49.7088 27.6232 51.034 25.3713L54.9668 27.3259L32.9804 38.252L10.9922 27.3259L32.9786 16.3979L37.3213 18.5555ZM40.7355 21.9643C40.6304 21.8627 40.5723 21.7231 40.5705 21.578C40.5687 21.433 40.6267 21.2934 40.7301 21.19C40.8316 21.0885 40.9712 21.0305 41.1181 21.0323C41.2632 21.0323 41.401 21.0921 41.5025 21.1973L43.2703 22.9651L47.3336 18.9018C47.5458 18.6897 47.8903 18.6897 48.1024 18.9018C48.3145 19.114 48.3145 19.4585 48.1024 19.6706L43.7617 24.0113C43.6311 24.1401 43.4552 24.2144 43.2721 24.2144C43.089 24.2144 42.9131 24.1419 42.7843 24.0131L40.7355 21.9643Z",
    fill: "#302C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleAssetLeft);
export default __webpack_public_path__ + "static/media/CircleAssetLeft.28be54b1eaf060f16d10a21d6165f130.svg";
export { ForwardRef as ReactComponent };